import { renderRoot } from 'quartz-core/client';
import { Router, Route, Switch } from 'react-router-dom';
import { createBrowserHistory } from 'history';
import Application from './components/Application';
import { jsx as _jsx } from "react/jsx-runtime";
const getRootUrl = () => '/content-embed-ui';

/**
 * The simple content-embed-ui App.
 */
export default class App {
  start() {
    const history = createBrowserHistory({
      basename: getRootUrl()
    });
    renderRoot( /*#__PURE__*/_jsx("div", {
      "data-application-name": "content-embed-ui",
      children: /*#__PURE__*/_jsx(Router, {
        history: history,
        children: /*#__PURE__*/_jsx(Switch, {
          children: /*#__PURE__*/_jsx(Route, {
            path: "/",
            exact: true,
            component: Application
          })
        })
      })
    }));
  }
}